import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Box, Typography } from "@mui/material";
import { styles } from "./styles";

export const MinorPlanDetails = (): JSX.Element => {
  return (
    <Box>
      <Box sx={{ display: "flex" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "40px" }} variant="h4">
          $ 0
        </Typography>
        <Box sx={{ paddingLeft: "10px" }}>
          <h6 style={{ margin: 0 }}>per</h6>
          <h6>month</h6>
        </Box>
      </Box>
      <ul style={{ padding: "5px", marginTop: "10px", textAlign: "left" }}>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          5GB of Optimized Music & File Storage
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Basic AI-Based Music Organization
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Choose to Share Music Publicly or Privately
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Profile, Tracks, & NFTs Listed on Explore Page
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Dolby.io AI Mastering ($29.99/track)
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Smart Contract Minting ($29.99/track)
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Unlimited Encrypted Messaging with Users
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          Update Track Versions With Collaborators
        </li>
        <li style={styles.planDetailsRow}>
          <CheckCircleRoundedIcon sx={styles.checkCircleRoundedIcon} />
          File Share(Session Files, Lyric Sheets, etc)
        </li>
      </ul>
    </Box>
  );
};
